import { render, staticRenderFns } from "./SelectProperty.vue?vue&type=template&id=580bbd18&scoped=true"
import script from "./SelectProperty.vue?vue&type=script&lang=js"
export * from "./SelectProperty.vue?vue&type=script&lang=js"
import style0 from "./SelectProperty.vue?vue&type=style&index=0&id=580bbd18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580bbd18",
  null
  
)

export default component.exports